/**
 * KULON hangsav az atirathoz.
 *
 * ─── Miert nem eleg a hivas mikrofonsavja? ──────────────────────────────────
 *
 * Mert az EMBERI FULNEK van hangolva, nem a felismeronek. A hivas sávja
 * `noiseSuppression` es `autoGainControl` mellett keszul: a zajszuro olyan
 * spektralis tartalmat is levag, amibol a felismero dolgozik, az automatikus
 * erosites pedig pumpalja a szintet. Egy telefonbeszelgetesben ez jol
 * hangzik; egy gepi atiratban abbol latszik, hogy a valodi mondatok
 * felismerhetetlen szoveggé esnek szet.
 *
 * Ezert az atirat sajat felvetelt kap ugyanarrol az eszkozrol, ezekkel a
 * beallitasokkal:
 *
 *   echoCancellation: true   ← MARAD, es ez nem alku targya
 *   noiseSuppression: false
 *   autoGainControl:  false
 *
 * ─── Miert marad az visszhangszures? ────────────────────────────────────────
 *
 * Mert AZ tartja igazza az egesz atirat-modellunket: "mindenki a sajat hangjat
 * veszi fel". Nelkule a hangszorobol beleszol a masik fel hangja is, es
 * ugyanaz a mondat ketszer, ROSSZ NEVVEL kerul az atiratba - ami rosszabb,
 * mint egy pontatlan szoveg, mert hamis tanut allit.
 *
 * ─── Ha nem sikerul ─────────────────────────────────────────────────────────
 *
 * A masodik felvetel nem mindig johet letre: van eszkoz es bongeszo, ami egy
 * mikrofont csak egyszer ad ki. Ilyenkor `null`-lal terunk vissza, es a hivo a
 * hivas sávjaval veszi fel - gyengebb atirat, de atirat. A funkcio nem all le
 * azert, mert a jobbik ut nem jarhato.
 */

/**
 * Az atirat-felvetel megnyitasa - UGYANARROL az eszkozrol, mint a hivas.
 *
 * Az eszkoz-azonositot a hivas savjabol vesszuk at: enelkul a bongeszo az
 * "alapertelmezett" mikrofont adna, ami lehet egy masik eszkoz - es akkor az
 * atirat mast hallana, mint amit a tobbiek.
 */
export async function openTranscriptStream(
  micTrack: MediaStreamTrack,
): Promise<MediaStream | null> {
  if (typeof navigator === 'undefined' || !navigator.mediaDevices?.getUserMedia) return null;

  const deviceId = micTrack.getSettings().deviceId;

  try {
    return await navigator.mediaDevices.getUserMedia({
      audio: {
        ...(deviceId ? { deviceId: { exact: deviceId } } : {}),
        echoCancellation: true,
        noiseSuppression: false,
        autoGainControl: false,
      },
    });
  } catch {
    return null;
  }
}

/** A sav elengedese. Enelkul a mikrofon-jelzo bekapcsolva maradna a hivas utan. */
export function closeTranscriptStream(stream: MediaStream | null): void {
  if (!stream) return;
  for (const track of stream.getTracks()) track.stop();
}
